<div
  class="global-filters-bar"
  [class.mobile]="(screenSize$ | async)?.isMobile"
  *ngIf="
    !(
      routing.isInvest() ||
      routing.isHot() ||
      routing.isChat() ||
      routing.isReport()
    )
  "
>
  <div class="global-filters-bar__group">
    <span class="global-filters-bar__label">Timeframe</span>
    <app-timeframe-selector></app-timeframe-selector>
  </div>

  <div class="global-filters-bar__group">
    <span class="global-filters-bar__label">Score</span>
    <app-score-button></app-score-button>
  </div>

  <div class="global-filters-bar__group">
    <span class="global-filters-bar__label">Language</span>
    <app-language-toggle></app-language-toggle>
  </div>

  <div class="global-filters-bar__group">
    <app-menu-filters></app-menu-filters>
  </div>
</div>
